<template>
    <section class="o-services-modal-sidebar-otg">
        <span class="sidebar-label">
            {{ headerLabel }}
        </span>
        <div class="sidebar-container">
            <button 
                v-for="(item, index) in preparedItems"
                :key="item.id"
                type="button"
                :class="['sidebar-button', item.cssClass]"
                @click="handleClick(index)"
            >
                <div
                    v-if="item.icon"
                    class="icon-container"
                >
                    <img
                        :src="item.icon"
                        :alt="item.altText"
                        class="icon"
                    >
                </div>
                <div class="info-wrapper">
                    <span class="floor-info">
                        {{ item.name }}
                    </span>
                    <span v-if="item.floor && isShowFloorInfo" class="floor-info">
                        {{ item.floor }}
                    </span>
                    <span
                        v-if="item.distance"
                        class="distance-info"
                    >
                        {{ item.distanceMessage }} {{ $t('ui.meter') }}
                    </span>
                </div>
            </button>
        </div>
    </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: 'OServicesModalSidebarOtg',
    props: {
        items: {
            type: Array,
            required: true
        },
        headerLabel: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapGetters([
            't',
            'getMapConfigProp'
        ]),
        preparedItems() {
            const items = [...this.items];
            const t = this.t;

            return items
                .map((service, index) => {
                    const floor = t(service, 'floor') || '';
                    const distanceMessage = index === 0
                        ? `${this.$t('ui.the-nearest')}: ${service.distance}`
                        : `${this.$t('ui.distance')}: ${service.distance}`

                    return {
                        ...service,
                        floor,
                        distanceMessage
                    }
                })
        },
        blurCssClass() {
            return this.preparedItems.length > 5 ? 'sidebar-container-blur-effect' : null;
        },
        isShowFloorInfo() {
            if (this.componentParams.hasOwnProperty('is_show_floor_info')) {
                return this.componentParams.is_show_floor_info
            }
            return true
        },
        componentParams() {
            return this.getMapConfigProp('components.OServicesModalSidebarOtg.params') || {};
        }
    },
    methods: {
        handleClick(index) {
            this.$emit('onServiceClick', index)
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />
